import React, { useState } from "react";

export const LINE_PRICE_EDIT_INTRO_KEY = "linePriceEditIntroDismissed";

export const isLinePriceEditIntroDismissed = () => {
  try {
    return localStorage.getItem(LINE_PRICE_EDIT_INTRO_KEY) === "1";
  } catch (error) {
    return false;
  }
};

export const dismissLinePriceEditIntro = () => {
  try {
    localStorage.setItem(LINE_PRICE_EDIT_INTRO_KEY, "1");
  } catch (error) {
    // ignore storage errors
  }
};

const LinePriceEditIntroModal = ({ onConfirm, onClose }) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleConfirm = () => {
    if (dontShowAgain) {
      dismissLinePriceEditIntro();
    }
    onConfirm();
  };

  return (
    <>
      <div className="bg-gray z-nn" onClick={onClose} />
      <div className="line-price-edit-intro">
        <div className="line-price-edit-intro-icon">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 2V22M17 5H9.5C8.11929 5 7 6.11929 7 7.5C7 8.88071 8.11929 10 9.5 10H14.5C15.8807 10 17 11.1193 17 12.5C17 13.8807 15.8807 15 14.5 15H7"
              stroke="#0085FF"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h2>کاربر گرامی</h2>
        <p>
          تغییر مبلغ کالا فقط برای این فاکتور اعمال می‌شود و مبلغ اصلی تغییر
          نخواهد کرد. با ورود دوباره به صفحه کالاها قیمت به حالت قبل
          بازخواهد گشت.
        </p>
        <label className="line-price-edit-intro-check">
          <input
            type="checkbox"
            checked={dontShowAgain}
            onChange={(event) => setDontShowAgain(event.target.checked)}
          />
          <span>دیگر به من نمایش نده</span>
        </label>
        <button type="button" className="line-price-edit-intro-btn" onClick={handleConfirm}>
          تایید
        </button>
      </div>
    </>
  );
};

export default LinePriceEditIntroModal;
